export default __webpack_public_path__ + "static/N0252-1a384a23ae5d1331273036d8e927c861.png";